import { RouteConfig } from '@acsbe/routing';
import { RouterContext } from '../../router';
import signup from './modalFlow';

const pages: NonNullable<RouteConfig<RouterContext>['pages']> = [signup];

export default pages;
